import { render, staticRenderFns } from "./PmModalBox.vue?vue&type=template&id=b32e9fb0&scoped=true&"
import script from "./PmModalBox.vue?vue&type=script&lang=ts&"
export * from "./PmModalBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32e9fb0",
  null
  
)

export default component.exports